module.exports = __webpack_public_path__ + "static/media/staff-access.3b6a81ee.svg";